import { render, staticRenderFns } from "./power-order-curve.vue?vue&type=template&id=f64df222&scoped=true&"
import script from "./power-order-curve.vue?vue&type=script&lang=js&"
export * from "./power-order-curve.vue?vue&type=script&lang=js&"
import style0 from "./power-order-curve.vue?vue&type=style&index=0&id=f64df222&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64df222",
  null
  
)

export default component.exports